import type { Part } from './chatReducer';
import type { CrewStep, StepTone } from './crewSteps';
import type { ImportStepName } from './types';

const ORDER: { step: ImportStepName; title: string }[] = [
  { step: 'read', title: 'Reading the sheet' },
  { step: 'extract', title: 'Finding rate tables' },
  { step: 'check', title: 'Checking every number' },
  { step: 'compare', title: 'Comparing with current pricing' },
];

const TONES: Record<string, StepTone> = {
  started: 'active',
  done: 'done',
  failed: 'failed',
};

const WORDS: Partial<Record<StepTone, string>> = {
  active: 'Working…',
  done: 'Done',
  failed: 'Failed',
  stopped: 'Stopped',
};

/**
 * The rate-sheet import's steps (read, extract, check, compare), for the same
 * strip the crew uses. Each step shows its latest import_progress event; a step
 * still `started` once the turn is no longer live was cut off, so it reads
 * "Stopped". Empty when the turn has no import progress.
 */
export function buildImportSteps(parts: Part[], live: boolean): CrewStep[] {
  const latest = new Map<string, { status: string; detail: string | null }>();
  for (const part of parts) {
    if (part.kind === 'import_progress') latest.set(part.step, part);
  }
  if (latest.size === 0) return [];
  return ORDER.map(({ step, title }): CrewStep => {
    const event = latest.get(step);
    if (!event) return { stage: step, title, tone: 'wait', description: '' };
    let tone = TONES[event.status] ?? 'active';
    if (tone === 'active' && !live) tone = 'stopped';
    return {
      stage: step,
      title,
      tone,
      description: [WORDS[tone], event.detail ?? '']
        .filter(Boolean)
        .join(' · '),
    };
  });
}
